import {
  Box,
  List,
  ListItem,
} from '@chakra-ui/react';
import { FaHouseChimney } from 'react-icons/fa6';
import { IconType } from 'react-icons/lib';
import { Link, useRouteMatch } from 'react-router-dom';
import { useContext } from 'react';

import { ProfileContext } from '@app/contexts/profile';
import { getRoleName } from '@app/utils/jwt';

import { navigation } from '../../../navigation';
import { Txt } from '../text';
import { MenuItemCounter } from './counter';

export const Menu = () => {
  const { profile } = useContext(ProfileContext);

  return (<List bgColor='dark.900'>
    <MenuItem 
      icon={FaHouseChimney} 
      title="Главная" 
      to="/" 
      isHome
    />
    {profile &&
      navigation(getRoleName()).map(
        ({ id, name, children }, index) => (
          <Box key={`${index}_${id}`} mb={2}>
            <ListItem borderTop="1px solid" borderColor="dark.400" px={2} py={1}>
              <Txt
                color="white"
              >
                {name}
              </Txt>
            </ListItem>
            {children.map(
              ({ id: childId, name: childName, icon, to, counterId }, index) => (
                <MenuItem
                  icon={icon}
                  to={to}
                  title={childName}
                  counterId={counterId}
                  key={`${index}_${childId}`}
                />
              )
            )}
          </Box>
        )
      )}
  </List>);
};

interface MenuItemProps {
  icon: IconType;
  to: string;
  title: string;
  isHome?: boolean;
  counterId?: string
}

const MenuItem = ({ icon: ItemIcon, title, to, isHome, counterId }: MenuItemProps) => {
  const match = useRouteMatch(to);

  const isMatch = match?.isExact;

  return <Link to={to}><ListItem _hover={{ 
      bgColor: 'dark.600', 
    }} 
    bgColor={isMatch ? 'dark.600' : isHome ? 'dark.800' : 'unset'}
    display='flex' alignItems='flex-start' gap={2} px={2} py={isHome ? 2 : 1} 
  >
    <ItemIcon fill={isMatch ? 'var(--chakra-colors-gray-200)' : 'var(--chakra-colors-dark-100)'} style={{ minWidth: 16, marginTop: 2 }} />
    <Txt color={isMatch ? 'gray.200' : 'gray.400'} fontSize="sm" flexGrow={1}>{title}</Txt>
    {counterId && <MenuItemCounter counterId={counterId} />}
  </ListItem></Link>;
};
